module.exports = __webpack_public_path__ + "img/validate-file.a39dd071.svg";